<template>
  <div v-if="mostrarReferencia || (mostrarBadge && temBackorder)" class="atendimento-resumo">
    <span v-if="mostrarReferencia">{{ referencia }}</span>
    <span v-if="mostrarBadge && temBackorder" class="badge badge-light-info" title="Pedido com backorder" aria-label="Pedido com backorder">BO</span>
  </div>
</template>

<script>
export default {
  props: {
    atendimento: { type: Object, default: null },
    pedidoId: { type: [String, Number], default: '' },
    mostrarReferencia: { type: Boolean, default: true },
    mostrarBadge: { type: Boolean, default: true },
  },
  computed: {
    referencia() { return (this.atendimento && this.atendimento.referenciaPrincipal) || this.pedidoId; },
    disponivel() { return !!this.atendimento && this.atendimento.disponivel === true; },
    resumo() { return (this.atendimento && this.atendimento.resumo) || {}; },
    temBackorder() {
      return this.disponivel && Number.isInteger(this.resumo.totalBackorders)
        && this.resumo.totalBackorders > 0;
    },
  },
};
</script>

<style scoped>
.atendimento-resumo {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  white-space: nowrap;
}
</style>